(function(){
  'use strict';
  function alias(selector,id){
    if(document.getElementById(id))return;
    var target=document.querySelector(selector);
    if(!target)return;
    var marker=document.createElement('span');
    marker.id=id;
    marker.style.cssText='display:block;position:relative;top:-110px;visibility:hidden;';
    target.insertBefore(marker,target.firstChild);
  }
  function boot(){
    var path=window.location.pathname;
    alias('.ggs-order-builder-section','order-flowers-form');
    alias('.ggs-offer-section','offer');
    if(path.indexOf('muse-collection')>-1)alias('.ggs-editorial-section','muse-story');
    if(path.indexOf('husbands-club')>-1)alias('.ggs-cards-section','process');
    if(path.indexOf('husbands-club-setup')>-1)alias('.ggs-form-section-wrap','occasion-setup');
    if(path.indexOf('weddings-events')>-1){alias('.ggs-gallery-section','event-gallery');alias('.ggs-form-section-wrap','event-inquiry');}
    if(path.indexOf('/contact')>-1)alias('.ggs-form-section-wrap','contact-form');
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  document.addEventListener('shopify:section:load',boot);
})();
